var map = {
	"./gg-cn.png": "7Tzm",
	"./gg-de.png": "Pwye",
	"./gg-en.png": "WuUd",
	"./gg-es.png": "+++n",
	"./gg-fr.png": "Xay1",
	"./gg-pt.png": "L91j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24YN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/gg ^\.\/gg\-.*\.png$
// module id = 24YN
// module chunks = 1